// styles
import './styles.scss'
// components
import Slider from 'react-slick'
import { FirstStep } from 'modules/Programs/components/molecules/Steps/firstStep'
import { SecondStep } from 'modules/Programs/components/molecules/Steps/secondstep'
import { ThirdStep } from 'modules/Programs/components/molecules/Steps/thirdStep'
import Loading from 'components/atoms/loading/loading'
import { FourthStep } from 'modules/Programs/components/molecules/Steps/fourthStep'
// hooks
import { useControlOnboarding } from './hook'

/**
 * SampleNextArrow is a function that takes in a prop called onClick and returns a div with a className
 * of arrow next and an onClick event that calls the onClick prop.
 */
function SampleNextArrow(props) {
	const { onClick } = props
	return <div className='arrow next' onClick={onClick} />
}

/**
 * SamplePrevArrow is a function that returns a div with a class of 'arrow back' and an onClick event
 * that calls the onClick function passed in as a prop.
 */
function SamplePrevArrow(props) {
	const { onClick } = props
	return <div className='arrow back' onClick={onClick} />
}

/* The settings for the slider. */
const settings = {
	dots: true,
	infinite: false,
	slidesToShow: 1,
	slidesToScroll: 1,
	nextArrow: <SampleNextArrow />,
	prevArrow: <SamplePrevArrow />,
	dotsClass: 'button__bar'
}

/* A React component that renders a slider with 4 slides. */
export const SlideOnBoarding = () => {
	const {
		loading,
		onboardingUno,
		onboardingDos,
		onboardingTres,
		onboardingCuatro,
		sliderRef,
		gotoNext,
		handleCurrentSlide,
		onClickClose
	} = useControlOnboarding()

	if (loading) return <Loading small />

	return (
		<Slider ref={sliderRef} {...settings} afterChange={handleCurrentSlide}>
			<FirstStep onClick={onClickClose} contentData={onboardingUno} gotoNext={gotoNext} />
			<SecondStep onClick={onClickClose} contentData={onboardingDos} gotoNext={gotoNext} />
			<ThirdStep onClick={onClickClose} contentData={onboardingTres} gotoNext={gotoNext} />
			<FourthStep onClick={onClickClose} contentData={onboardingCuatro} gotoNext={gotoNext} />
		</Slider>
	)
}
